import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import {
  AutomationEventTypes,
  AutomationHandler,
  AutomationHelpers,
  AutomationTypes,
  AutomationViewGroup,
  selectAutomationGroupsByEvent,
} from '@tokeet-frontend/automations'
import { FormBuilder, FormControl } from '@angular/forms'
import { filter, map, take, startWith, switchMap, distinctUntilChanged } from 'rxjs/operators'
import * as lodash from 'lodash'
import {
  Destroyable,
  distinctObjectUntilChangedByFields,
  isSomething,
  untilDestroy,
} from '@tokeet-frontend/tv3-platform'
import { Actions, ofType } from '@ngrx/effects'
import { AutomationWizardChangeEventAction } from '@tv3/containers/automations/automations-wizard/automations-wizard.actions'

@Directive()
export abstract class AutomationWizardPanelBaseComponent extends Destroyable implements OnInit {
  @Input() viewType: 'table' | 'list' = 'list'

  @Output() typeChange = new EventEmitter<AutomationTypes>()
  abstract type: AutomationTypes

  form = this.fb.group({
    event: [],
    channels: [[]],
    rentals: [[]],
    days: [0],
    hours: [0],
  })

  get eventCtrl() {
    return this.form.get('event') as FormControl
  }

  get selectedEvent() {
    return this.eventCtrl.value
  }

  get isTimeEvent() {
    return AutomationHelpers.isTimeEvent(this.selectedEvent)
  }

  events = AutomationEventTypes
  automation$: Observable<AutomationViewGroup>
  automations$: Observable<AutomationViewGroup[]>

  eventHandlers = AutomationHandler
  automationTypes = AutomationTypes

  guestNotificationMessages: Record<string, { subject?: string; message: string }> = {} as any
  userNotificationMessages: Record<string, { subject?: string; message: string }> = {} as any

  protected constructor(protected actions: Actions, protected store: Store<any>, protected fb: FormBuilder) {
    super()
  }

  ngOnInit() {
    this.actions.pipe(ofType(AutomationWizardChangeEventAction), untilDestroy(this)).subscribe((action) => {
      this.eventCtrl.setValue(action.event)
    })

    // Reset days and hours when event changes
    this.eventCtrl.valueChanges.pipe(untilDestroy(this)).subscribe((event) => {
      this.form.patchValue({
        hours: 0,
        days: 0,
      })
    })

    this.automations$ = this.eventCtrl.valueChanges.pipe(
      startWith(this.selectedEvent),
      switchMap((event) => this.store.pipe(select(selectAutomationGroupsByEvent(event)))),
      map((items) => lodash.filter(items, (item) => !!item.attributes?.autopilot))
    )

    this.automation$ = this.automations$.pipe(map((items) => lodash.head(items)))

    this.automation$
      .pipe(distinctObjectUntilChangedByFields(['event']), untilDestroy(this))
      .subscribe((automation: AutomationViewGroup) => {
        this.form.patchValue({
          channels: automation?.channels || [],
          rentals: automation?.rentals || [],
        })
      })
  }

  onSelectEvent(event: AutomationEventTypes) {
    this.form.patchValue({ event })
  }
}
